import React from 'react';
import './loader.css';
import { TLoaderProps } from 'components/Loader/Loader.types';

const Loader: React.FC<TLoaderProps> = ({ isLoading }): React.ReactElement | null => {
	if (!isLoading) return null;

	return <div className={'loader'} />;
};

export default Loader;
